module.exports = __webpack_public_path__ + "img/doc.95248463.svg";